import { type CSSProperties, type PropsWithChildren, type ReactElement } from 'react';
import { Toaster } from 'sonner';

import { ToastCloseIcon, ToastErrorIcon, ToastSuccessIcon } from '@shared/components';

import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';

export function AppProviders({ children }: Readonly<PropsWithChildren>): ReactElement {
  return (
    <QueryProvider>
      <ThemeProvider>
        {children}
        <Toaster
          position="top-right"
          expand
          visibleToasts={5}
          gap={12}
          closeButton
          toastOptions={{
            classNames: {
              toast:
                'font-sans bg-white flex items-start min-w-[343px] w-[384px] rounded-lg border border-[#D5D7DA] p-4 gap-3',
              content: 'flex-1 min-w-0',
              title: 'text-[14px] leading-[20px] font-medium text-[#111827] tracking-normal pr-6',
              description:
                'text-[14px] leading-[20px] font-normal text-[#71767F] tracking-normal mt-0.5',
              closeButton:
                'static ml-auto bg-transparent border-none p-0 flex items-center justify-center',
            },
            style: {
              boxShadow: '0px 0px 6px -2px #00000026, 0px 10px 15px -3px #0000001A',
              fontFamily: 'Inter, sans-serif',
            } as CSSProperties,
          }}
          icons={{
            success: <ToastSuccessIcon className="h-6 w-6 shrink-0" />,
            error: <ToastErrorIcon className="h-6 w-6 shrink-0" />,
            close: <ToastCloseIcon className="h-3.5 w-3.5" />,
          }}
        />
      </ThemeProvider>
    </QueryProvider>
  );
}
